// extracted by mini-css-extract-plugin
export var quillEditor = "_jf-1";
export var variable = "_jf-0";